import React, {useState, useEffect, useRef} from "react";
import assets from "../assets/imgs";
import CalendarPopup from "./CalendarPopup";
import config from "../config/config";
const API_URL = config.API_URL;

function CommuteChangeBox({onClose, handleSave, selectedData = {},}){
  const [data, setData] = useState(selectedData);
  const [loading, setLoading] = useState(true);
  const [companyList, setCompanyList] = useState([]);

  const popupAnchorRef = useRef(null);
  
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(null);

  const handleDatePickerOpen = (key, event) => {
    event.stopPropagation();
    popupAnchorRef.current = event.target; // 클릭된 DOM 저장
    setIsDatePickerOpen(key);
  };

  const getStartupList = async () =>{
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/api/incubator/getCompanyNameList`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const result = await response.json();
      if (result.result) {
        const formattedData = result.value.map((data, index) => {
          let formatted = { 
            _id: data.startup_id || index + 1, 
            id: index + 1,
            name : data.name,
          }; // 기본 ID 설정
          console.log(formatted);
        
          return formatted;
        });
        setCompanyList(formattedData);

      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    getStartupList();
  }, []);
  const handleUpdate = async ()=>{
    
    if(!data.startup_id){
      alert('스타트업을 선택해 주세요');
      return;
    }
    if(!data.date){
      alert('날짜를 선택해 주세요');
      return;
    }
    if(!data.commute){
      alert('출근 종류를 선택해주세요');
      return;
    }else if(data.commute == '결근'){
      alert('결근은 현재 선택 불가합니다.');
      return;
    }else if(selectedData.commute == '출근' && data.commute =='출근'){
      alert('이미 출근 처리된 상태입니다.');
      return;
    }
    try {      
      const response = await fetch(`${API_URL}/api/incubator/changeCommute`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(data),
      });
      const result = await response.json();

      if (!response.ok){
        alert(`업로드에 실패하였습니다. (관리자에 문의하여 주시기 바랍니다.), ${result.message}`);
        return;
      } 
      // const result = await response.json();
      if (result.result) {
        alert('변경완료 되었습니다.');
        window.location.reload();
      } else {
        alert(`${result.message}`);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } 
  };
  const handleChange = (field, value) => {
    setData((prev) => {
      let newContents = { ...prev, [field]: value };
  
      if (field === "date" && new Date() < new Date(newContents.date)) {
        alert("지난 날짜만 변경할수 있습니다.");
        //지난날인지 아닌지
        return prev; // 상태를 그대로 유지
      }
      return newContents;
    });
  }

  // 닫기 시리즈 시작
  const handleClose = () =>{
    setData({});
    onClose(false);
  }  
  // 모달 바깥 클릭 시 닫기
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) handleClose();
  };
  //esc 키 닫기
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [handleClose]);
  //닫기 시리즈 끝

  console.log('data: ', data);
  
  return (
    <div style={styles.overlay} onClick={handleOverlayClick}>
      <div style={{...styles.modal,}}>
        <div style={styles.header}>
          <h3 className='font-s-head4-semibold'>{`출근 통계 수정`}</h3>
          <div style={styles.topRightHeader}>
            <div style={styles.xBox} onClick={handleClose}>
              <assets.icons.icon_x/>
            </div>
          </div>
        </div>
        <div style={styles.body}>
          {/* 타이틀 입력 */}
          <>
            <div style={styles.setSection}>
              <h3 className='font-body4-semibold'>기업명</h3>
              <select
                value={data.startup_id || ""}
                onChange={(e) => handleChange("startup_id", e.target.value)}
                style={styles.textInput}
              >
                {loading ? (
                  <option value="" disabled>불러오는 중입니다.</option>
                ):(
                  <>
                    <option value="" disabled>선택</option>
                    {companyList.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </>
                )}
                
              </select>
            </div>
            <div style={styles.setSection}>
              <h3 className='font-body4-semibold'>날짜</h3>
              <div style={{...styles.textInput, cursor: "pointer"}} onClick={(e) => 
                  handleDatePickerOpen('date', e)
                  }>
                <p>{data['date'] || ""}</p>
                <assets.icons.icon_calendar_filled/>
              </div>              
              {isDatePickerOpen === 'date' && (
                <CalendarPopup
                  selectedDate={data['date']}
                  onSelect={(date) => handleChange('date', date)}
                  onClose={() => setIsDatePickerOpen(null)}
                  anchorRef={popupAnchorRef}
                />
              )}
            </div>
            <div style={styles.setSection}>
              <h3 className='font-body4-semibold'>출결</h3>
              <select
                value={data.commute || ""}
                onChange={(e) => handleChange("commute", e.target.value)}
                style={styles.textInput}
              >
                <option value="" disabled>선택</option>
                <option key={'출근'} value="출근">
                  출근
                </option>
                <option key = {"결근"} value ="결근" disabled>
                  결근
                </option>
              </select>
            </div>
          </>

          <div style={styles.btnLine}>
            <div style={styles.btnUpload} onClick={handleUpdate} className='font-body2-semibold'>출석 변경하기</div>
          </div>
        </div>
        
      </div>
    </div>
  );
}

const topRightHeaderIcon = {
  cursor:"pointer",
  width: "20px",
  height:"20px"
};

const styles ={
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // 반투명 배경
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "white",
    borderRadius: "20px",
    width: "40%",
    height: "60%",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    position: "relative",
    display: "flex",
    flexDirection: "column"
  },
  header:{
    display: "flex",
    alignItems: "center",
    backgroundColor: "var(--grayscale_20)",
    justifyContent: "space-between",
    padding: "14px 20px",
    borderTopRightRadius : "20px",
    borderTopLeftRadius : "20px"
  },
  topRightHeader: {
    display: "flex",
    gap: "40px",
    alignItems: "center",
  },
  xBox:{
    ...topRightHeaderIcon,
    display:"flex",
    alignItems:"center",
    justifyContent: "center",    
  }, 
  body:{
    display: "flex",
    flexDirection : "column",
    padding: "35px 35px 40px 35px",
    flex: 1,
    overflow: "auto"
  },
  setSection:{
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    marginBottom: "20px",
  },
  textInput:{
    height: "45px", borderRadius: "8px", border: "1px solid var(--grayscale-cool_50)", padding: "0px 12px" ,
    display: "flex", alignItems: "center", minHeight: "45px", gap: "8px"
  },
  dateInput: {
    display:"flex", gap: "10px", height: "45px", borderRadius: "8px", border: "1px solid var(--grayscale-cool_50)", padding: "0px 12px", 
    alignItems: "center", position:"relative", flex: 1
  },
  btnLine: {
    display: "flex",
    justifyContent: "flex-end",
  },
  calendarIcon: {
    width:"20px",
    height: "20px"
  },
  quillStyle:{
    // borderRadius: "8px", border: "1px solid var(--grayscale-cool_50)",
    // padding: "12px",
    marginBottom: "80px",
    flex: 1
  },
  quillOutputStyle:{
    borderRadius: "8px", border: "1px solid var(--grayscale-cool_50)",
    padding: "12px",
    flex: 1
  },
  btnUpload: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    backgroundColor : "var(--primary-crimson_40)",
    borderRadius: "8px",
    cursor: "pointer",
    height: "48px", width:"150px"
  }
}

export default CommuteChangeBox;